import { Question } from '../../../types';
import { TagsField } from '../../components';

interface IntegerQuestionConfigProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function IntegerQuestionConfig({
  question,
  onEdit,
}: IntegerQuestionConfigProps) {
  return (
    <div className="space-y-2">
      <TagsField
        value={question.tags || []}
        onChange={(tags) => onEdit(question.id, { tags })}
      />
    </div>
  );
}
